import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  checkPermision,
  dateDefault,
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
// import { UserCreate } from "./UserCreate";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { FormHelperText } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import { fetchClient } from "../client/clientSlice";
import { fetchParty } from "../party/partySlice";
import { ModalClientRadio } from "../inbound/ModalClientRadio";
import { addMovement, selectLoading } from "./movementSlice";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const MovementCreate = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataService = useSelector(selectParameter);
  const dataJobType = useSelector(selectParameter2);

  const forceUpdate = useForceUpdate();

  const [typeParty, setTypeParty] = useState("");

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchParameter({
          paramgroup_code: "SERVICES_CLASS_STOCKTAKE",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "CRITERIA",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchClient({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );

      await dispatch(
        fetchParty({
          party_setting: "MANUFACTURER",
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  const [formValues, setFormValues] = useState({
    client: {
      value: "",
      error: false,
      required: "Y",
    },
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    job_date: {
      value: dateDefault,
      error: false,
      required: "Y",
    },
    ete: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    ets: {
      value: dateDefault,
      error: false,
      required: "N",
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      client: formValues.client.value,
      job_date: formValues.job_date.value,
      estimated_start: formValues.ets.value,
      estimated_end: formValues.ete.value,
    };

    try {
      const response = await dispatch(addMovement(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          history.push(
            `/motor-pool/movement/edit/${response.payload.data.data.movement_id}`
          );
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const serviceOptions = dataService.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const jobTypeOptions = dataJobType.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeService = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["service_class"]: {
        ...formValues["service_class"],
        value,
      },
    });
  };

  const handleChangeJobType = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["criteria"]: {
        ...formValues["criteria"],
        value,
      },
    });
  };

  // modal

  const [showClient, setShowClient] = useState(false);
  const [showLocationMaster, setShowLocationMaster] = useState(false);
  const [showParty, setShowParty] = useState(false);

  const [typeLocation, setTypeLocation] = useState("");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <ThemeProvider theme={formLabelsTheme}>
              {/* Basic Detail */}
              <div>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          required
                          label="Client"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.client_name.value}
                          readOnly
                          error={formValues.client.error}
                          helperText={
                            formValues.client.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowClient(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.client_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["client"]: {
                                  ...formValues["client"],
                                  value: "",
                                },
                                ["client_name"]: {
                                  ...formValues["client_name"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Estimated Time to Start"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="ets"
                          value={formValues.ets.value}
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          required
                          label="Job Date"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="job_date"
                          value={formValues.job_date.value}
                          onChange={handleChange}
                          error={formValues.job_date.error}
                          helperText={
                            formValues.job_date.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Estimated Time to End"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="ete"
                          value={formValues.ete.value}
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/* handleSave */}
                <Row className="mt-6 justify-content-end">
                  <Button variant="primary" onClick={handleSave}>
                    Save
                  </Button>
                </Row>
              </div>
            </ThemeProvider>
          </CardBody>
        </Card>

        {/* Modal Create */}
        <ModalClientRadio
          isOpen={showClient}
          setShow={setShowClient}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFields}
          fields={fields}
        />
      </div>
    </>
  );
};
